import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useMyLikedColorsStore = create()(
  persist(
    (set, get) => ({
      likedColors: [],
      addColor: (color) => {
        const previousLikedColors = new Set(get().likedColors);
        previousLikedColors.add(color);
        set({ likedColors: [...previousLikedColors] });
      },
      removeColor: (color) => {
        const previousLikedColors = new Set(get().likedColors);
        previousLikedColors.delete(color);
        set({ likedColors: [...previousLikedColors] });
      },
      resetColors: () => set({ likedColors: [] }),
      _hasHydrated: false,
      _setHasHydrated: (hasHydrated) => set({ _hasHydrated: hasHydrated }),
    }),
    {
      onRehydrateStorage: (state) => {
        return () => state._setHasHydrated(true);
      },
      name: "valspar-paint-liked-colors",
    }
  )
);
